///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { GtthHistoryService } from '../../../logical-topology/engine/history-service';
import { GtthDuplicatedNodeFeatureDto } from './model/duplicated-node-feature-dto.model';
import { NodeFeature } from '../../../logical-topology/entities/node/node-feature';
import { DuplicateTypeEnum } from './duplicate-type-enum';

@Component({
    selector: 'winde-node-duplications-resolver',
    templateUrl: './node-duplications-resolver.component.html',
    styleUrls: ['./node-duplications-resolver.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthNodeDuplicationsResolverComponent implements OnInit {
    public searchText: string;
    public isAreaCollapsed: boolean;
    public topologyNodes: NodeFeature[];
    public duplicatedNewNodes: GtthDuplicatedNodeFeatureDto[][];

    private map: Map<number, GtthDuplicatedNodeFeatureDto[]>;

    constructor(private readonly historyService: GtthHistoryService) {}

    @Input() set duplicatedNodesMap(map: Map<number, GtthDuplicatedNodeFeatureDto[]>) {
        this.map = map;
        this.topologyNodes = [];
        for (const id of map.keys()) {
            this.topologyNodes.push(this.historyService.logicalTopology.getStation(id));
        }
    }

    @Input() set duplicatedNewNodesArray(duplicatedNodesArray: GtthDuplicatedNodeFeatureDto[][]) {
        if (duplicatedNodesArray?.length) {
            this.duplicatedNewNodes = duplicatedNodesArray.slice();
            this.makeFirstNodesNew();
        }
    }

    ngOnInit(): void {
        this.isAreaCollapsed = true;
    }

    toggleCollapsed() {
        this.isAreaCollapsed = !this.isAreaCollapsed;
    }

    getImportedNodes(topologyNodeId: number): GtthDuplicatedNodeFeatureDto[] {
        return this.map.get(topologyNodeId);
    }

    getOriginsList(importedNode: GtthDuplicatedNodeFeatureDto, nodesArray: GtthDuplicatedNodeFeatureDto[]) {
        return nodesArray.filter((node) => node.getId() !== importedNode.getId() && node.getType() === DuplicateTypeEnum.NEW);
    }

    private makeFirstNodesNew() {
        this.duplicatedNewNodes.forEach((nodesArray: GtthDuplicatedNodeFeatureDto[]) => {
            nodesArray[0].setType(DuplicateTypeEnum.NEW);
        });
    }
}
